export const patientNavbarOptions = [
  { label: 'Dashboard', icon: 'dashboard-mono', path: '/myportal' },
  { label: 'Messages', icon: 'messages-mono', path: '/myportal/inbox' },
  { label: 'Treatment Plans', icon: 'pentool-mono', path: '/myportal/treatment-plans' },
  { label: 'Appointments', icon: 'calendar-mono', path: '/myportal/appointments' },
  { label: 'Forms', icon: 'note-2-mono', path: '/myportal/forms' },
  { label: 'Payments', icon: 'wallet-mono', path: '/myportal/payments' },
  { label: 'Superbills', icon: 'medal-dollar-mono', path: '/myportal/superbills' },
  { label: 'Medications', icon: 'pill-mono', path: '/myportal/medications' },
  { label: 'Documents', icon: 'export-mono', path: '/myportal/documents' },
  { label: 'Referrals', icon: 'referrals', path: '/myportal/referrals' },
  { label: 'Orders', icon: 'note-text-1-mono', path: '/myportal/orders' },
  { label: 'My Account', icon: 'user-2-mono', path: '/myportal/account' },
  { label: 'Logout', icon: 'logout-2-mono', path: null }
];

// {
//   label: 'Medications',
//   icon: 'health-mono',
//   path: '/myportal/medical-records'
// },
// {
//   label: 'Questionnaires',
//   icon: 'note-filled',
//   path: '/myportal/questionnaires'
// },
// {
//   label: 'Invoices',
//   icon: 'billing-mono',
//   path: '/myportal/invoices'
// }
